import { makeStyles } from '@material-ui/styles'
import { colors } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },

  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  labelInput: {
    fontSize: '16px',
  },
  card: {
    background: theme.palette.backGroundItem.card,
  },
  cardContent: {
    paddingTop: theme.spacing(2),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minWidth: '100px',
  },
  subtitle: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.primary.warning,
  },

  divArquivos: {
    padding: theme.spacing(1),
  },
  divTitulo: {
    borderBottom: 'thin solid #DDD',
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
  tableHeader: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#E4E6E8',
  },
  tableRow: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f4f6f8',
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)',
    },
  },
  tableContainer: {
    borderRadius: '12px',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(224, 224, 224, 1)'}`,
    overflow: 'hidden',
  },
  mainModal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  mobileCard: {
    padding: theme.spacing(2.5),
    borderRadius: '12px',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : '#ffffff',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(10, 37, 64, 0.08)'}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.015)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.24)' : 'rgba(10, 37, 64, 0.15)',
      transform: 'translateY(-1px)',
    },
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'}`,
    paddingBottom: theme.spacing(1),
  },
  mobileActionTitle: {
    fontWeight: 700,
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
    letterSpacing: '0.5px',
  },
  mobileDetailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  mobileDetailItem: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    lineHeight: '1.4',
    marginBlock: '4px',
    width: '100%',
    '& span': {
      color: theme.palette.text.primary,
      fontWeight: 500,
      textAlign: 'right',
      marginLeft: theme.spacing(1.5),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flex: 1,
      minWidth: 0,
    },
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4, 2),
    color: theme.palette.text.secondary,
  },
}))


export default useStyles
